import React, { useState, useEffect } from "react";
import BalcaoVirtualService, { Balcao } from "../../services/BalcaoVirtualService";
import { isServerError } from "../../config/api";
import { getUser } from "../../services/AuthService";
import Modal from "../../components/Modal";
import Alert from "../../components/Alert";
import "./style.css";

interface Props {
  show: boolean;
  onHide?(): void;
}

const STATUS_LABELS: { [key: string]: string } = {
  available: "Disponível",
  busy: "Ocupado",
  unavailable: "Indisponível",
};

export default function Balcoes({ show, onHide }: React.PropsWithChildren<Props>) {

  const errorServer = "Não foi possível estabelecer uma conexão com o servidor. Tente novamente mais tarde.";
  const [balcoes, setBalcoes] = useState<Balcao[]>([]);
  const [error, setError] = useState("");

  const isAdmin = () => {
    try {
      const user = JSON.parse(getUser() || "");
      const adminTemp = user.roles.map((option: any) => option.activities.includes("admin:all"));
      return Boolean(adminTemp[0]);
    } catch {
      return false;
    }
  };

  const loadBalcoes = async () => {
    await BalcaoVirtualService.balcoes()
      .then((response) => setBalcoes(response))
      .catch((err) => {
        if (isServerError(err)) { setError(err.error); } else { setError(errorServer); }
      });
  };

  useEffect(() => {
    if (isAdmin() && show) {
      loadBalcoes();
    }
  }, [show]);

  const statusLabel = (status: string) => STATUS_LABELS[status] || status;

  const formatDate = (date?: string) => (date ? new Date(date).toLocaleString("pt-BR") : "-");

  const setUnavailable = async (balcao: Balcao) => {
    const aviso = balcao.status === "busy"
      ? "\n\nEste balcão está em atendimento e a sessão em andamento será encerrada."
      : "";
    if (!window.confirm(`Deseja tornar indisponível o balcão "${balcao.name}"?${aviso}`)) {
      return;
    }
    setError("");
    await BalcaoVirtualService.adminSetStatus(balcao.id, "unavailable")
      .then(() => {
        setError(`Balcão "${balcao.name}" tornado indisponível com sucesso!`);
        loadBalcoes();
      })
      .catch((err) => {
        if (isServerError(err)) { setError(err.error); } else { setError(errorServer); }
      });
  };

  return (
    <div className="modal-balcoes">
      <Modal show={show} onHide={onHide} centered>
        <div className="text-center">
          <span className="h3 modal-title-balcoes mt-3">
            <strong>Gerenciar Balcões</strong>
            <hr />
          </span>
          <div className="px-5">
            <span className="sub-title-modal">
              Visualize e altere o status dos balcões. Torne "Indisponível" para destravar um balcão ocupado.
            </span>
          </div>
        </div>
        <div className="content-modal-balcoes mt-5">
          <div className="container">
            {error && (<Alert>{error}</Alert>)}
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">BALCÃO</th>
                    <th scope="col">STATUS</th>
                    <th scope="col">ATENDENTE</th>
                    <th scope="col">ÚLTIMA ATIVIDADE</th>
                    <th scope="col">AÇÕES</th>
                  </tr>
                </thead>
                <tbody className="balcoes-list">
                  {balcoes?.map((balcao, index) => {
                    return (
                      <tr key={index}>
                        <td><span>{balcao.name}</span></td>
                        <td><span className={`status-badge status-${balcao.status}`}>{statusLabel(balcao.status)}</span></td>
                        <td><span>{balcao.attendant_name || "-"}</span></td>
                        <td><span>{formatDate(balcao.attendance_last_seen)}</span></td>
                        <td className="btn-group-balcoes">
                          {balcao.status !== "unavailable" && (
                            <button type="button" className="btn-unavailable" onClick={() => setUnavailable(balcao)}>
                              Tornar Indisponível
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                  {balcoes.length === 0 && (
                    <tr><td colSpan={5}><span>Nenhum balcão encontrado.</span></td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
